import { FC } from "react";
import { HStack, Text } from "@chakra-ui/react";

interface Props {
  title: string;
  amount: string;
}

export const ScheduleItemDetailsText: FC<Props> = ({ title, amount }) => {
  return (
    <HStack fontSize="12px" lineHeight="11px" justifyContent="space-between" pb="6px">
      <Text>{title}</Text>
      <Text>{amount}</Text>
    </HStack>
  );
};
